import { $post } from '@/api/request'
// 待办消息列表
export function todoList (data) {
  return $post({
    url: '/index/todoList',
    data
  })
}
// 合同到期提醒
export function noticeList (data) {
  return $post({
    url: '/index/noticeList',
    data
  })
}
// [未读->已读]操作–合同到期提醒
export function readOperate (data) {
  return $post({
    url: '/index/noticeReadOperate',
    data
  })
}
